import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { legalApi } from '../../api/legalApi';
import { LegalDocsView } from '../components/LegalDocsView';

export function Legal() {
  const nav = useNavigate();
  const { data, isLoading } = useQuery({ queryKey: ['legal'], queryFn: () => legalApi.getStatus() });
  const docs = data?.documents ?? [];

  return (
    <div className="rf-detail">
      <div className="rf-topbar">
        <button className="rf-back" onClick={() => nav(-1)}>
          <ChevronLeft /> Назад
        </button>
        <div className="rf-topbar-title">Правовая информация</div>
      </div>

      <div className="rf-detail-scroll">
        {isLoading && <div className="rf-info">Загрузка…</div>}
        {!isLoading && <LegalDocsView docs={docs} />}
      </div>
    </div>
  );
}

export default Legal;
